<template>
    <SliceZone :slices="slices" :components="components" />
</template>

<script setup lang="ts">
    import {inject, ref} from 'vue';
    import type {PrismicDocument} from '@prismicio/types';
    import {SliceZone} from '@prismicio/vue';
    import {useAsyncData} from 'nuxt/app';
    import {useRoute, createError} from '#imports';
    import {usePrismicDocument} from '~/composables/content/usePrismicDocument';
    import {useABTestSlices} from '~/composables/useABTestSlices';
    import {PRISMIC_DOCUMENT} from '~/keys';
    import {components} from '~/slices/components';

    const props = defineProps<{
        pageType: string;
    }>();

    const route = useRoute();

    const {fetchDocument} = usePrismicDocument(props.pageType, route.params.uid as string);
    const document = inject(PRISMIC_DOCUMENT, ref());
    const {data, error} = await useAsyncData<PrismicDocument>('child-page-' + route.params.uid, () => fetchDocument(), {deep: true});
    if (error.value) {
        throw createError(error.value);
    }
    document.value = data.value!;
    const {slices} = useABTestSlices(document.value);
</script>

<style lang="scss">
    @use '~/assets/styles/page.scss';
    @include page.page-style;
</style>
